module.exports = __webpack_public_path__ + "img/deleteicon.d8d3a5f6.svg";